require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-lost-paradise-2018-review.json") })
        }
      }, "path---feature-lost-paradise-2018-review");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-lost-paradise-2018-review!./.cache/json/feature-lost-paradise-2018-review.json
// module id = 642
// module chunks = 231608221292675